import { render, staticRenderFns } from "./IconNotsupport.vue?vue&type=template&id=827fb7fa&"
import script from "./IconNotsupport.vue?vue&type=script&lang=js&"
export * from "./IconNotsupport.vue?vue&type=script&lang=js&"
import style0 from "./IconNotsupport.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports